import { render, staticRenderFns } from "./ResetPasswordMerchantUserModal.vue?vue&type=template&id=79af599c&scoped=true&"
import script from "./ResetPasswordMerchantUserModal.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordMerchantUserModal.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordMerchantUserModal.vue?vue&type=style&index=0&id=79af599c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79af599c",
  null
  
)

export default component.exports